import isPc from '@flight-workspace/common-client/src/util/isPc';
import classNames from 'classnames/bind';
import styles from './Footer.module.scss';

const cx = classNames.bind(styles);

const Footer = () => {
  return (
    <div className={cx('Footer')}>
      <p className={cx('txt')}>
        <span className={cx('line')}>
          최근 조회된 결과로 업데이트 되며, 실제 예약
        </span>
        <wbr />
        <span className={cx('line')}>가능한 가격과 다를 수 있습니다.</span>
        <a
          className={cx('info')}
          href="#"
          title="더보기"
          data-event-nlog="click"
          data-event-area-code="cal.calhelp"
          onClick={e => {
            e.preventDefault();
            window.open(
              isPc(window?.innerWidth)
                ? 'https://help.naver.com/support/contents/contents.help?serviceNo=11270&categoryNo=20346'
                : 'https://m.help.naver.com/support/contents/contentsView.nhn?contentsNo=9381&lang=ko',
            );
          }}
        />
      </p>
    </div>
  );
};

export default Footer;
